export * from 'screens/game/markup/game.markup';